<template>
  <div v-if="getMain?.fileData?.isImage || getMain?.fileData?.isSvg || getMain?.fileData?.isVideo" class="photo-wrapper" :style="cssVars">
    <!-- VIDEO -->
    <ContentGeneratorElementsApiVideo
      v-if="getMain?.fileData?.isVideo"
      :value="value"
      :aspect-ratio="aspectRatio"
      :aspect-ratio-mobile="aspectRatioMobile"
      :is-no-border-radius="isNoBorderRadius"
    />
    <!-- IMAGE & SVG -->
    <!-- zamiast content jest media bo przekazujemy media, które zawierają main i mobile -->
    <!-- SVG jest teraz obsługiwane w ApiImage -->
    <ContentGeneratorElementsApiImage
      v-else-if="getMain?.fileData?.isImage || getMain?.fileData?.isSvg"
      :value="value"
      :size-image="sizeImage"
      :aspect-ratio="aspectRatio"
      :aspect-ratio-mobile="aspectRatioMobile"
      :is-no-border-radius="isNoBorderRadius"
    />
  </div>
</template>

<script>
import { contentFindContent } from '../../../plugins/content'
import ContentGeneratorElementsApiVideo from './ApiVideo.vue'
import ContentGeneratorElementsApiImage from './ApiImage.vue'
export default {
  components: {
    ContentGeneratorElementsApiVideo,
    ContentGeneratorElementsApiImage
  },
  props: {
    aspectRatio: {
      type: String,
      default: null
    },
    aspectRatioMobile: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
    sizeImage: {
      type: String,
      default: 'w1000'
    },
    isNoBorderRadius: {
      type: Boolean,
      defalt: false
    }
  },
  computed: {
    getMain () {
      return contentFindContent(this.value?.content, 'main')
    },
    cssVars () {
      return {
        '--aspect-ratio': this.aspectRatio,
        '--aspect-ratio-mobile': this.aspectRatioMobile
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-wrapper {
  width: 100%;
  aspect-ratio: var(--aspect-ratio);
  position: relative;
  // background-color: $light-gray;
  @include mobile {
    aspect-ratio: var(--aspect-ratio-mobile);
  }
}
</style>
